import CryptoJS from 'crypto-js';

// Shared secret key — in production this should be per-conversation derived key
const SECRET_KEY = 'Qtalk@QualTechEdge@2026@SecureKey';

export const encryptMessage = (plainText) => {
  if (!plainText) return plainText;
  try {
    return CryptoJS.AES.encrypt(plainText, SECRET_KEY).toString();
  } catch(e) {
    console.error('Encryption failed:', e);
    return plainText;
  }
};

export const decryptMessage = (cipherText) => {
  if (!cipherText) return cipherText;
  try {
    // Try to decrypt — if it fails, return as-is (old unencrypted messages)
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || cipherText; // fallback to original if decryption gives empty
  } catch(e) {
    return cipherText; // old messages not encrypted
  }
};
